import React, { useState } from 'react';
import { Sidebar, Navbar } from './index';
import AssistantWidget from './AssistantWidget';
import { WorkspaceBoundary } from './AppGuard';
import { useAuth } from '../context/AuthContext';
import { isAgencyAdminRole } from '../config/menuCodeMap';

/**
 * Layout Wrapper for Dashboard Pages
 * Contains sidebar and navbar
 */
const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false); // New state for desktop collapse
  // Ask Patch. The button that opens it is in the header, the panel is down
  // here, so the state that joins them has to live above both.
  const [assistantOpen, setAssistantOpen] = useState(false);
  // Ask Patch answers from a care organisation's data — an agency has none.
  // Nor is it for an agency carer at a home: it reaches far beyond the few
  // modules that home granted them (the API refuses it for them as well).
  const { user } = useAuth();
  const showAssistant = !isAgencyAdminRole(user) && !user?.agency_worker;

  return (
    <WorkspaceBoundary>
    <div className="flex h-screen bg-white dark:bg-[#1b1f26] text-gray-900 dark:text-gray-100 transition-colors duration-300">
      <Sidebar
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />

      {/* Dynamic margin: md:ml-20 when collapsed, md:ml-64 when expanded */}
      <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${isCollapsed ? 'md:ml-20' : 'md:ml-64'}`}>
        <Navbar
          isOpen={sidebarOpen}
          setIsOpen={setSidebarOpen}
          assistantOpen={assistantOpen}
          onAskPatch={showAssistant ? () => setAssistantOpen((v) => !v) : undefined}
        />
        {/* Light grey content backdrop so white cards/boxes stand out.
            Dark mode keeps its existing near-black background. */}
        <main className="flex-1 overflow-y-auto bg-[#EEF2F6] dark:bg-[#1b1f26]">
          {/* Keep h-full here: ScheduleScreen and ZoneRoster set `h-full` on
              their own root and need a definite height from this wrapper. */}
          <div className="p-6 md:p-8 h-full">{children}</div>
        </main>
      </div>

      {/* Help assistant — available on every dashboard page, opened from the
          "Ask Patch" button in the header. The panel is mounted HERE rather
          than in the Navbar because the navbar's backdrop-blur makes it a
          containing block for `fixed` children, which would pin this panel
          inside a 56px-tall bar. */}
      {showAssistant && <AssistantWidget open={assistantOpen} setOpen={setAssistantOpen} />}
    </div>
    </WorkspaceBoundary>
  );
};

export default DashboardLayout; 